import * as T3_Ajax from 'T3_AJAX';

const SELECTOR_FEEDBACK_FORM = '.vd-form.vd-form--feedback';

const actions = () => {
  $(document).on('click', '[data-action]', function (e) {
    let _self = $(this);
    switch (_self.attr('data-action')) {
      case 'open-feedback':
        e.preventDefault();
        openFeedback(_self);
        break;
      case 'close-feedback':
        e.preventDefault();
        closeFeedback(_self);
        break;
      case 'send-feedback':
        e.preventDefault();
        if (_self.hasClass('status--enabled')) {
          sendFeedback(_self);
        }
        break;
    }
  });

  $(document).on('click', '.vd-modal-background', function () {
    closeFeedback($('[data-action="close-feedback"]'));
  });
};

const init = () => {
  if ($(SELECTOR_FEEDBACK_FORM).length > 0) {
    validate();
  }
};

const closeFeedback = (_caller) => {
  let modal = _caller.parents('.vd-modal');

  modal.velocity('reverse', {
    duration: 500,
    easing: window.Easings.IN_EXPO,
    begin: function () {
      $('.vd-modal-background').velocity('reverse', { duration: 350, easing: window.Easings.SNAP });
      $('html,body').css('overflow', 'hidden');
      $('.body__container').velocity('reverse', {
        duration: 500,
        easing: window.Easings.IN_EXPO,
      });
      modal.removeClass('status--open');
    },
    complete: function () {
      if (_caller.parents('.vd-actions').length > 0) {
        _caller.attr('data-action', 'open-feedback');
      }

      modal.find('> .vd-actions').find('.vd-btn').attr('data-action', 'open-feedback');
      modal.addClass('status status--closed');
    },
  });
};

const countChars = (_caller) => {
  return _caller.val().length;
};

const openFeedback = (_caller) => {
  let modal = _caller.parents('.vd-modal');

  modal.velocity(
    {
      left: '0px',
    },
    {
      duration: 500,
      easing: window.Easings.IN_EXPO,
      begin: function () {
        $('html,body').css('overflow', 'hidden');
        $('.body__container').velocity(
          {
            left: modal.outerWidth() + 'px',
          },
          {
            duration: 500,
            easing: window.Easings.IN_EXPO,
          }
        );
        $('.vd-modal-background').velocity(
          {
            left: '-36px',
            opacity: 100,
            width: '200%',
          },
          {
            duration: 350,
            easing: window.Easings.SNAP,
          }
        );
        modal.removeClass('status--closed');
      },
      complete: function () {
        if (_caller.parents('.vd-actions').length > 0) {
          _caller.attr('data-action', 'close-feedback');
        }
        modal.addClass('status status--open');
      },
    }
  );
};

const sendFeedback = (_caller) => {
  const _form = _caller.parents('.vd-form');
  const _textField = _form.find('textarea');

  const message = encodeURIComponent(_textField.val());
  console.log(message);

  let params = {
    action: 'sendFeedback',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    pid: _caller.attr('data-pid'),
    message: message,
  };

  T3_Ajax.call(
    params,
    _caller,
    function (params, _caller) {
      _caller.parents('.vd-form').velocity(
        {
          opacity: 0.25,
        },
        {
          begin: function () {
            _caller.removeClass('status--enabled').addClass('status--disabled');
            _caller.parents('form').find('textarea').attr('readonly', 'readonly');
            console.log(_caller.parents('form').find('textarea'));
          },
          duration: 500,
        }
      );
    },
    function (params, _caller, data) {
      //_caller.parents('.vd-form').find('textarea').prop("readonly", false);
      _caller.parents('form').find('textarea').prop('readonly', false);
      _caller.removeClass('status--disabled').addClass('status--enabled');

      if (data.success) {
        _caller.parents('.vd-form').velocity('slideUp', {
          duration: 250,
          complete: function () {
            let message = $(
              '<div class="vd-message vd-message--success"><p>' + data.message + '</p></div>'
            );
            message.hide(0);

            _caller.parents('.vd-modal__container').append(message);
            message.velocity('slideDown', {
              duration: 250,
            });
          },
        });
      }
    }
  );
};

const validate = () => {
  const LIMIT = 1;

  const _form = $(SELECTOR_FEEDBACK_FORM);
  const _textField = _form.find('textarea');

  if (countChars(_textField) >= LIMIT) {
    switchButtonStatus('enable');
  } else {
    switchButtonStatus('disable');
  }

  _textField.on('input', function () {
    if (countChars($(this)) >= LIMIT) {
      switchButtonStatus('enable');
    } else {
      switchButtonStatus('disable');
    }
  });
};

const switchButtonStatus = (status) => {
  const _form = $(SELECTOR_FEEDBACK_FORM);
  const _button = _form.find('.vd-btn');

  if (status === 'enable') {
    _button.removeClass('status--disabled').addClass('status status--enabled');
  } else {
    _button.removeClass('status--enabled').addClass('status status--disabled');
  }
};

/**
 * export methods
 */

export { actions, init };
